import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { CaseAcquisitionStatus, CasesService } from '../../../service/cases.service';
import { LoginService } from 'src/app/services/login.service';

export type StatusConfirmDialogData = {
  leadId: number;
  lastObservation: string;
  previousStatus: CaseAcquisitionStatus;
  currentStatus: CaseAcquisitionStatus;
};
@Component({
  selector: 'app-status-confirmation',
  templateUrl: './status-confirmation.component.html',
  styleUrls: ['./status-confirmation.component.scss'],
})
export class StatusConfirmationComponent {
  note = '';

  constructor(
    private readonly loginService: LoginService,
    private readonly dialogRef: MatDialogRef<StatusConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: StatusConfirmDialogData,
    private readonly service: CasesService
  ) {}

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.service
      .updateStatus(this.data.leadId, {
        status: this.data.currentStatus,
        observation: !!this.note ? this.note : null,
      })
      .pipe(
        catchError((error) => {
          this.loginService.showMessage('Ops, ocorreu um erro ao atualizar o lead!');
          return throwError(() => error);
        })
      )
      .subscribe(() => {
        this.dialogRef.close({ lastObservation: this.note });
      });
  }
}
